import ApiService from '@/plugins/apiService'
import { cloneDeep } from 'lodash-es'

export default {
  state: {
    databases: [],
    databasesToCreate: []
  },

  mutations: {
    SET_DATABASES(state, databases) {
      state.databases = databases
    },
    SET_DATABASES_TO_CREATE(state, databases) {
      state.databasesToCreate = databases
    }
  },

  actions: {
    async fetchDatabases({ commit }) {
      const { data } = await ApiService.getDatabases()
      commit('SET_DATABASES', data)
    },

    async fetchDatabasesToCreate({ commit }) {
      const { data } = await ApiService.getDatabasesToCreate()
      commit('SET_DATABASES_TO_CREATE', data)
    }
  },

  getters: {
    getDatabaseById: state => id => {
      return cloneDeep(state.databases.find(db => db.id === id))
    }
  }
}
